// Vendors
import { Injectable } from '@angular/core';
import { SecuredResponse } from '@shared/classes/secured-response.class';
import { TwoFaApiService, TwoFaCredentialsResponseData } from '@core/services/api/2fa-api.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class TwoFaService {
  private isTwoFaInProcess: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private readonly list2FaErrors: string[] = [
    'TWO_FA_REG_REQUIRED',
    'TWO_FA_MISSING',
    'TWO_FA_WRONG',
    'CONSTRAINT_VALIDATION_ERROR'
  ]

  constructor(
    private twoFaApiService: TwoFaApiService
  ) {}

  get twoFaProcess$(): Observable<boolean> {
    return this.isTwoFaInProcess.asObservable();
  }

  is2FaError(error: SecuredResponse): boolean {
    return this.list2FaErrors.includes(error.data.codeName);
  }

  startTwoFaProcess(): void {
    this.isTwoFaInProcess.next(true);
  }

  endTwoFaProcess(): void {
    this.isTwoFaInProcess.next(false);
  }

  getUiQcode(email: string): Observable<TwoFaCredentialsResponseData> {
    return this.twoFaApiService.getRegInfo(email);
  }

  reset2Fa(email: string, callbackUrl?: string): Observable<boolean> {
    return this.twoFaApiService.reset2Fa(email, callbackUrl);
  }

}
